interface Props {
  readonly size: number;
}

export default function WalletConnectIcon(props: Props) {
  const { size } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 5a5 5 0 0 1 5-5h22a5 5 0 0 1 5 5v22a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5V5Z"
        fill="#07071D"
      />
      <path
        d="M10.1 13.27a8.48 8.48 0 0 1 11.8 0l.4.38a.4.4 0 0 1 0 .58l-1.34 1.32a.21.21 0 0 1-.3 0l-.54-.53a5.91 5.91 0 0 0-8.24 0l-.58.57a.21.21 0 0 1-.3 0l-1.34-1.32a.4.4 0 0 1 0-.58l.43-.42ZM24.67 16l1.2 1.17a.4.4 0 0 1 0 .58L20.48 23a.42.42 0 0 1-.58 0l-3.83-3.74a.1.1 0 0 0-.14 0L12.1 23a.42.42 0 0 1-.59 0l-5.39-5.27a.4.4 0 0 1 0-.58l1.2-1.17a.42.42 0 0 1 .59 0l3.82 3.74c.04.04.1.04.15 0L15.7 16a.42.42 0 0 1 .6 0l3.82 3.74c.04.04.1.04.15 0L24.09 16a.42.42 0 0 1 .6 0Z"
        fill="#fff"
      />
    </svg>
  );
}
